export default __webpack_public_path__ + "i18n/translations/translation-es.9261eaf2.json";